import React from 'react'

type Variant = 'primary' | 'success' | 'danger' | 'warning' | 'dark' | 'neutral' | 'outline-danger' | 'outline-warning' | 'ghost'
type Size = 'sm' | 'md' | 'lg' | 'full'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: Size
  icon?: React.ReactNode
  children?: React.ReactNode
}

const variantClasses: Record<Variant, string> = {
  primary: 'bg-blue-600 text-white hover:bg-blue-700',
  success: 'bg-green-600 text-white hover:bg-green-700',
  danger: 'bg-red-600 text-white hover:bg-red-700',
  warning: 'bg-amber-500 text-white hover:bg-amber-600',
  dark: 'bg-gray-800 text-white hover:bg-gray-900',
  neutral: 'border border-gray-300 text-gray-700 bg-white hover:bg-gray-50',
  'outline-danger': 'border border-red-300 text-red-600 hover:bg-red-50',
  'outline-warning': 'border border-amber-300 text-amber-700 hover:bg-amber-50',
  ghost: 'text-blue-600 hover:text-blue-800',
}

const sizeClasses: Record<Size, string> = {
  sm: 'px-3 py-1 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-5 py-2.5 text-sm',
  full: 'w-full py-2.5 text-sm',
}

export default function Button({
  variant = 'primary',
  size = 'md',
  icon,
  children,
  className = '',
  ...props
}: ButtonProps) {
  return (
    <button
      className={[
        'font-medium transition-colors inline-flex items-center justify-center gap-1.5 rounded-full',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        variantClasses[variant],
        sizeClasses[size],
        className,
      ].join(' ')}
      {...props}
    >
      {icon}
      {children}
    </button>
  )
}
